
import React from 'react';
import { MdChevronLeft, MdChevronRight } from 'react-icons/md';
import './Pagination.css';

const Pagination = ({
    currentPage,
    totalPages,
    onPageChange,
    totalRecords,
    currentCount,
    entityName = "records",
    limit,
    onLimitChange,
    maxVisible = 5
}) => {
    // Show pagination even for 1 page so "design" is visible, but disable buttons
    // if (totalPages <= 1) return null;

    const renderPageNumbers = () => {
        const pages = [];
        let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
        let endPage = Math.min(totalPages, startPage + maxVisible - 1);

        if (endPage - startPage + 1 < maxVisible) {
            startPage = Math.max(1, endPage - maxVisible + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pages.push(
                <button
                    key={i}
                    className={`pagination-number ${currentPage === i ? 'active' : ''}`}
                    onClick={() => onPageChange(i)}
                >
                    {i}
                </button>
            );
        }
        return pages;
    };

    return (
        <div className="pagination-wrapper">
            {(totalRecords > 0 || currentCount > 0) && (
                <div className="pagination-info">
                    Showing <span className="highlight">{currentCount}</span> of{" "}
                    <span className="highlight">
                        {totalRecords || currentCount}
                    </span> {entityName}
                </div>
            )}
            <div className="pagination-container">
                <button
                    className="pagination-btn"
                    disabled={currentPage === 1}
                    onClick={() => onPageChange(currentPage - 1)}
                >
                    <MdChevronLeft size={20} />
                    {/* <span>Prev</span> */}
                </button>
                <div className="pagination-numbers">
                    {renderPageNumbers()}
                </div>
                <button
                    className="pagination-btn"
                    disabled={currentPage === totalPages}
                    onClick={() => onPageChange(currentPage + 1)}
                >
                    {/* <span>Next</span> */}
                    <MdChevronRight size={20} />
                </button>
            </div>
        </div>
    );
};

export default Pagination;
